export const PACKAGING_LIST_REQUEST = 'PACKAGING_LIST_REQUEST';
export const PACKAGING_LIST_SUCCESS = 'PACKAGING_LIST_SUCCESS';
export const PACKAGING_LIST_FAIL    = 'PACKAGING_LIST_FAIL';